import type { MouseEventHandler } from 'react';
import { useCallback } from 'react';

import { useKeyDown } from '../../hooks/useKeyDown';
import { useNewGame } from '../../hooks/useNewGame';
import { reset } from '../../reducers/game';
import { currentWordSelector, streakSelector, totalCompletedSelector } from '../../selectors/game';
import { useAppDispatch, useAppSelector } from '../../store';
import { Button } from '../button/Button';
import { KeyboardHint } from '../keyboard-hint/KeyboardHint';

export const Success = (): JSX.Element => {
  const dispatch = useAppDispatch();

  const currentWord = useAppSelector(currentWordSelector);
  const streak = useAppSelector(streakSelector);
  const totalCompleted = useAppSelector(totalCompletedSelector);

  const startNewGame = useNewGame();

  const goHome = useCallback(() => {
    dispatch(reset());
  }, [dispatch]);

  useKeyDown('Enter', startNewGame);
  useKeyDown('Escape', goHome);

  const onClickReset: MouseEventHandler<HTMLButtonElement> = () => {
    goHome();
  };

  const onClickNewGame: MouseEventHandler<HTMLButtonElement> = () => {
    startNewGame();
  };

  return (
    <div style={{ padding: '32px', textAlign: 'center' }}>
      Congratulations! You guessed <span style={{ fontWeight: 700 }}>{currentWord?.toUpperCase()}</span>
      <br />
      <br />
      {streak > 1 ? `Winning streak of ${streak}, with ` : ''}
      {totalCompleted} game{totalCompleted > 1 ? 's' : ''} completed.
      <br />
      <br />
      <Button onClick={onClickReset} style={{ backgroundColor: '#2196f3' }}>
        Home
      </Button>
      <Button onClick={onClickNewGame} style={{ backgroundColor: '#2196f3' }}>
        New Game
      </Button>
      <KeyboardHint>Press enter for a new game, or escape to go home</KeyboardHint>
    </div>
  );
};
